module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr6.198b8fb.png";